import { message } from 'antd';
import moment from 'moment';
import { BASE_URL1 } from '../routes/BackendRoutes';

export const curSym = '$';

export const pipSetAccessToken = (token) => {
  if (!token) return;
  else localStorage.setItem('eg_token', token);
};

export const pipGetAccessToken = () => {
  return localStorage.getItem('eg_token');
};

export const pipViewDate = (date) => {
  return moment(date).format("DD-MM-YYYY");
};

export const pipViewDate3 = (date) => {
  return moment.utc(date).format("DD/MM/YYYY");
};

export const pipViewDate2 = (date) => {
  return moment.utc(date).format("DD-MM-YYYY");
};

export const pipViewDate4 = (date) => {
  return moment.utc(date).format("YYYY-MM-DD");
};

export const pipViewDate5 = (date) => {
  return moment.utc(date).format("YYYY,MM,DD");
};

export const pipViewDateTime = (date) => {
  return moment.utc(date).format("DD/MM/YYYY HH:mm:ss");
};

export const pipViewTime = (date) => {
  return moment.utc(date).format("hh:mm:ss A");
};

export const pipDeleteToken = () => {
  localStorage.removeItem("m_user_data");
  localStorage.removeItem("eg_token");
  try {
    sessionStorage.removeItem("fm_tour_state_v1");
    sessionStorage.removeItem("fm_tooltip_seen_v1");
  } catch (_e) { }
  message.success("Successfully logged out");
};

export const pipDeleteTokenAuth = () => {
  localStorage.removeItem("m_user_data");
  localStorage.removeItem("eg_token");
  try {
    sessionStorage.removeItem("fm_tour_state_v1");
    sessionStorage.removeItem("fm_tooltip_seen_v1");
  } catch (_e) { }
};

export const pipSuccessMessage = (message) => {
  return message.success(message)
};

export const pipErrorMessage = (message) => {
  return message.error(message)
};

export const pipSaveProfile = (profile) => {
  if (!profile)
    return;
  localStorage.setItem('m_user_data', JSON.stringify(profile));
};

export const getFileName = (url) => {
  return url?.split("/").pop();
};

export const handleView = (url) => {
  if (!url) return;
  let fullUrl = url;
  if (!url.startsWith("http") && !url.startsWith("https")) {
    const cleanUrl = url.startsWith("/") ? url.substring(1) : url;
    fullUrl = `${BASE_URL1}${cleanUrl}`;
  }
  window.open(fullUrl, "_blank");
};

export const getFileType = (url) => {
  const ext = url?.split(".").pop()?.toLowerCase();

  if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
  if (ext === "pdf") return "pdf";
  if (["doc", "docx"].includes(ext)) return "doc";
  return "other";
};

export const pipGetProfile = () => {
  return JSON.parse(localStorage.getItem('m_user_data'));
};

export const getDaysLeft = (userSubscriptionPlane) => {
  if (!userSubscriptionPlane || userSubscriptionPlane.length === 0) return 0;
  const data = userSubscriptionPlane[0];

  // pick correct date (same logic you already use)
  let endDate =
    data?.trial_end_date || data?.renewed_at;

  if (!endDate && data?.start_date) {
    const d = new Date(data.start_date);
    if (data?.plan?.billingCycle?.toLowerCase() === "yearly") {
      d.setFullYear(d.getFullYear() + 1);
    } else {
      d.setMonth(d.getMonth() + 1);
    }
    endDate = d;
  }

  if (!endDate) return 0;

  const today = new Date();
  const expiry = new Date(endDate);

  // reset time to avoid partial day issues
  today.setHours(0, 0, 0, 0);
  expiry.setHours(0, 0, 0, 0);

  const diffTime = expiry - today;

  // convert ms â†’ days
  const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return daysLeft > 0 ? daysLeft : 0;
};

export const getDaysLeftLabel = (userSubscriptionPlane) => {
  const days = getDaysLeft(userSubscriptionPlane);

  if (days === 0) return "Expired";
  if (days === 1) return "1 day left";

  return `${days} days left`;
};


export const getOptionLabel = (options, value) => {
  const matchedOption = options.find((item) => item.value === value);

  return matchedOption ? matchedOption.label : "-";
};